export default __webpack_public_path__ + "static/media/codepen.b918e872.svg";